import type StepsRoute from 'teacher-ui-client/manage/rollover/steps/route'
import type StepsController from 'teacher-ui-client/manage/rollover/steps/controller'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { StepsNavComponent } from 'teacher-ui-client/components/steps-nav'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { t } from 'ember-intl'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { on } from '@ember/modifier'
import { or } from 'ember-truth-helpers'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import RouteTemplate from 'ember-route-template'
import perform from 'ember-concurrency/helpers/perform'
import type { TOC } from '@ember/component/template-only'

interface Signature {
  Args: {
    model: ModelFor<StepsRoute>
    controller: StepsController
  }
}
export const ManageRolloverStepsPage: TOC<Signature> = <template>
  <PageHeader>
    <:title>
      <h1>
        {{@controller.title}}
      </h1>
    </:title>
  </PageHeader>
  {{#if @controller.currentStepId}}
    <StepsNavComponent
      @subscriptionType={{@model.currentSubscriptionType}}
      @stepItems={{@controller.stepItems}}
      @currentStepId={{@controller.currentStepId}}
      @highestUnlockedStepId={{@controller.currentRollover.step}}
      @goToStep={{@controller.goToStep}}
    />
  {{/if}}

  <div class="rollover-step">
    {{outlet}}
  </div>
  {{#unless @controller.hideFooter}}
    <div class="steps-footer mx-auto max-w-3xl px-2">
      <hr class="my-6" />
      <div class="flex justify-between">
        <UiButton class="w-32" @appearance={{ButtonAppearance.muted}} {{on "click" @controller.previous}}>
          {{t "manage.rollover.previous"}}
        </UiButton>
        {{#if @controller.isLastStep}}
          <span>
            <UiButton
              class="w-56"
              disabled={{or @controller.isSubmitting @controller.isImportingStudents}}
              @appearance={{ButtonAppearance.regular}}
              {{on "click" (perform @controller.completeRolloverTask @controller.currentRollover)}}
            >
              {{#if @controller.isSubmitting}}
                <FidgetLoadingIndicatorComponent
                  @show={{true}}
                  @centered={{true}}
                  @appearance="small"
                  @overlay={{false}}
                />
              {{else}}
                {{t "manage.rollover.complete"}}
              {{/if}}
            </UiButton>
            {{#if @controller.isImportingStudents}}
              <Tooltip @text={{t "manage.rollover.completeDisabledTooltip"}} />
            {{/if}}
          </span>
        {{else}}
          <UiButton class="w-32" @appearance={{ButtonAppearance.muted}} {{on "click" @controller.next}}>
            {{t "manage.rollover.next"}}
          </UiButton>
        {{/if}}
      </div>
    </div>
  {{/unless}}
</template>

export default RouteTemplate(ManageRolloverStepsPage)
